var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 16.6458,
    stroke: "#1C1C1C",
    strokeWidth: 1.95833
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 32.3125V24.4791M17.625 24.4791V17.625C17.625 16.5434 18.5018 15.6666 19.5833 15.6666H25.4583C27.6214 15.6666 29.375 17.4202 29.375 19.5833V20.5625C29.375 22.7256 27.6214 24.4791 25.4583 24.4791H17.625Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.b9099d9919fedba3d38d99907d060567.svg";
export { ForwardRef as ReactComponent };